<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="col-12">
              <div class="row">
                <div class="col-12 py-3 px-4 pt-4">
                  <div class="d-flex justify-content-between">
                    <h3
                      class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                    >
                      Nuevo Pago
                    </h3>
                    <div class="">
                      <button
                        class="mt-2 btn-sm bg-primary text-white font-weight-normal border btn-outline-primary h5 btn d-flex flex-nowrap align-items-center"
                        @click.prevent="returnUrl"
                      >
                        <i class="bi bi-arrow-left mr-1"></i>
                        Volver
                      </button>
                    </div>
                  </div>
                  <form>
                    <div class="col-12 col-xl-10 px-0 pl-sm-3 m-auto">
                      <div class="row">
                        <div
                          class="col-12 col-md-6 pr-md-2 pl-md-2 pr-0 pl-0 py-0"
                        >
                          <div>
                            <label for="">Empresa</label>
                            <Multiselect
                              v-model="form.selected_company"
                              :options="companys"
                              label="company_name"
                              :show-labels="false"
                              placeholder="Seleccione una Opción"
                              id="typeStatus"
                              class="mt-1 mb-2"
                            ></Multiselect>
                          </div>
                          <div>
                            <label for="">Banco</label>
                            <Multiselect
                              v-model="form.bank"
                              :options="banks"
                              label="bank_name"
                              :show-labels="false"
                              placeholder="Seleccione un Banco"
                              id="typeStatus"
                              class="mt-1 mb-2"
                            ></Multiselect>
                          </div>
                          <div>
                            <label for="">Cobro</label>
                            <Multiselect
                              v-model="form.id_payment_fee"
                              :options="payment_fees"
                              label="title"
                              :show-labels="false"
                              placeholder="Seleccione una Opción"
                              id="typeStatus"
                              class="mt-1 mb-2"
                              @select="loadExpectedAmount($event)"
                              @remove="removeCurrency($event)"
                            ></Multiselect>
                          </div>
                          <div id="app" class="mt-4">
                            <file-pond
                              name="test"
                              ref="filePond"
                              label-idle="Agrega la imagen del comprobante aquí"
                              v-bind:allow-multiple="false"
                              accepted-file-types="image/jpeg, image/png, application/pdf"
                              :server="null"
                              v-bind:files="form.url_image"
                              @addfile="handleFileAdd"
                              @removefile="handleFileRemove"
                            />
                          </div>
                        </div>
                        <div
                          class="col-12 col-md-6 pl-md-2 pr-md-2 pl-0 pr-0 py-0"
                        >
                          <div>
                            <label for="">Fecha</label>
                            <input
                              type="date"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.payment_date"
                              required
                            />
                          </div>
                          <div>
                            <label for="">Tasa de cambio BCV</label>
                            <input
                              type="text"
                              ref="priceInput"
                              placeholder="Tasa BCV"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.current_bcv_rate"
                              v-format-price
                              required
                            />
                          </div>
                          <div>
                            <label for="">Número de referencia</label>
                            <input
                              type="email"
                              placeholder="Referencia del pago"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.reference_number"
                              required
                            />
                          </div>
                          <div>
                            <label for=""
                              >Monto por pagar ( Moneda de referencia:
                              <b>{{ currency }}</b> )</label
                            >
                            <input
                              type="email"
                              placeholder="Monto por pagar"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.expected_amount"
                              readonly
                            />
                          </div>
                          <div>
                            <label for="">Monto pagado ( Bs: )</label>
                            <input
                              type="text"
                              ref="priceInput"
                              placeholder="Monto"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.amount"
                              v-format-price
                              required
                            />
                          </div>
                          <div>
                            <label for="">Estado de pago</label>
                            <Multiselect
                              v-model="form.id_type_payment_status"
                              :options="type_payment_status"
                              label="name"
                              :show-labels="false"
                              placeholder=""
                              id="typeStatus"
                              class="mt-1 mb-2"
                            ></Multiselect>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="d-flex justify-content-end w-100 mt-2">
                        <button
                          class="bg-primary text-white font-weight-normal border btn-outline-primary h5 btn mb-0 mt-md-0 mb-2 mt-1"
                          @click.prevent="saveElement"
                        >
                          Guardar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'
import Cookies from 'js-cookie'

// Import MultiSelect
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  name: 'app',
  data() {
    return {
      form: {
        url_image: [],
        selected_company: '',
        payment_date: '',
        bank: '',
        amount: '',
        expected_amount: '',
        current_bcv_rate: '',
        reference_number: '',
        id_payment_fee: '',
        id_admin_approval: Cookies.get('id'),
        id_type_payment_status: ''
      },
      companys: [],
      payment_fees: [],
      banks: [],
      type_payment_status: [],

      currency: ''
    }
  },
  components: {
    FilePond,
    Multiselect
  },
  methods: {
    ...mapActions(['getData', 'createData', 'optimizeImage']),

    handleFileAdd(error, file) {
      if (!error) {
        this.form.url_image = [file.file] // Guardar solo el archivo
      }
    },

    handleFileRemove(file) {
      this.form.url_image = [] // Limpiar el campo al eliminar
    },
    loadCompanys() {
      const form = {
        url: 'user/all',
        params: {
          active: 1
        }
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.companys = response.data
              .filter((user) => user.company && user.id_company != 0)
              .map((user) => ({
                id_user: user.id,
                id_company: user.company.id,
                company_name: user.company.company_name
              }))
              .sort((a, b) => a.company_name.localeCompare(b.company_name))
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadPaymentFees() {
      const form = {
        url: 'payment_fee/all',
        params: {
          active: 1
        }
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.payment_fees = response.data
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadBanks() {
      const form = {
        url: 'cilara_bank/all',
        params: {
          active: 1
        }
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.banks = response.data.sort((a, b) =>
              a.bank_name.localeCompare(b.bank_name)
            )
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadTypePaymentStatus() {
      const form = {
        url: 'type_payment_status/all',
        params: {
          active: 1
        }
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.type_payment_status = response.data
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    isFormValid(form) {
      return (
        form.selected_company != null &&
        form.selected_company !== '' &&
        form.payment_date != null &&
        form.payment_date !== '' &&
        form.bank != null &&
        form.bank !== '' &&
        form.amount != null &&
        form.amount !== '' &&
        form.amount !== 0 &&
        form.expected_amount != null &&
        form.expected_amount !== '' &&
        form.current_bcv_rate != null &&
        form.current_bcv_rate !== '' &&
        form.current_bcv_rate !== 0 &&
        form.reference_number != null &&
        form.reference_number !== '' &&
        form.id_payment_fee != null &&
        form.id_payment_fee !== '' &&
        form.id_admin_approval != null &&
        form.id_admin_approval !== '' &&
        form.id_admin_approval !== 0 &&
        form.id_type_payment_status != null &&
        form.id_type_payment_status !== ''
      )
    },
    saveElement() {
      const filePondInstanceValid = this.$refs.filePond.getFiles()
      if (!this.isFormValid(this.form)) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, complete todos los campos para continuar.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      if (filePondInstanceValid.length === 0) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, agregue una imagen para continuar.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      const today = new Date().toISOString().split('T')[0]
      const paymentDate = this.form.payment_date

      if (paymentDate > today) {
        Swal.fire({
          title: 'Fecha inválida',
          text: 'No se puede introducir una fecha mayor a la actual.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }

      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de guardar este pago?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,

        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, Guardar'
      }).then(async (result) => {
        if (result.value) {
          const formData = new FormData()

          const filePondInstance = this.$refs.filePond.getFiles()
          if (filePondInstance[0] && filePondInstance[0].file) {
            const compressedImage = await this.optimizeImage(
              filePondInstance[0].file
            )
            formData.append('url_image', compressedImage)
          }

          formData.append('id_company', this.form.selected_company.id_company)
          formData.append(
            'company_name',
            this.form.selected_company.company_name
          )
          formData.append('id_user', this.form.selected_company.id_user)
          formData.append('payment_date', this.form.payment_date)
          formData.append('payment_bank_name', this.form.bank.bank_name)
          formData.append('amount', this.form.amount)
          formData.append('current_bcv_rate', this.form.current_bcv_rate)
          formData.append('reference_number', this.form.reference_number)
          formData.append('id_payment_fee', this.form.id_payment_fee.id)
          formData.append('id_admin_approval', this.form.id_admin_approval)
          formData.append(
            'id_type_payment_status',
            this.form.id_type_payment_status.id
          )

          const form = {
            url: 'payment/save',
            data: formData
          }

          this.createData(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: 'Pago guardado correctamente',
                  icon: 'success',

                  confirmButtonText: 'Aceptar'
                }).then(() => {
                  this.returnUrl()
                })
              } else if (response.code === 409) {
                Swal.fire({
                  title: 'Error',
                  text: 'Ya existe un pago con este nombre.',
                  icon: 'error',

                  confirmButtonText: 'Aceptar'
                })
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error, intente más tarde.',
                icon: 'error',

                confirmButtonText: 'Aceptar'
              })
            })
        }
      })
    },
    loadExpectedAmount(event) {
      console.log(event.expected_amount)
      this.form.expected_amount = event.expected_amount
      this.currency = event.type_currency.name
    },
    removeCurrency(event) {
      this.form.expected_amount = ''
      this.currency = ''
    },
    returnUrl() {
      this.$router.go(-1)
    }
  },
  mounted() {
    this.loadCompanys()
    this.loadPaymentFees()
    this.loadBanks()
    this.loadTypePaymentStatus()
  }
}
</script>

<style>
.filepond--credits {
  display: none !important;
}
</style>
